module.exports = __webpack_public_path__ + "static/0054-789ca37ba77609320ecb8467ce9b7f91.png";